// initial state
import * as base from './base.js'
const baseName = '/admin/system/feedback'

const feedbackReply = baseName + '/list'

const obj = base.setBaseUrl('feedback', baseName)
const a = Object.assign(obj, {feedbackReply})
export default a
